<template>
  <suc-select-component
    v-if="options && options.length > 0"
    :title="$t('components.fields.establishment.title')"
    :options="options"
    label="establishmentDescr"
    :form="form"
    :name="name"
  >
    <template #no-options>{{ $t("components.fields.no_options") }}</template>
  </suc-select-component>
</template>

<script>
import { SucSelectComponent, SUC_SELECT_CHANGED_EVENT, Form } from "@/components/form";

import api from "@/api/establishment";

export default {
  components: {
    SucSelectComponent,
  },
  props: {
    initValue: {
      type: String,
    },
    name: {
      type: String,
      required: true,
    },
    form: {
      type: Form,
      required: true,
    },
  },
  data() {
    return {
      options: [],
      value: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { data } = await api.getEstablishments();
      console.log("Establishments API Response:", data);
      // Filter out items with null establishmentCode or null establishmentDescr
      this.options = data.filter(
        (item) =>
          item.establishmentCode !== null &&
          item.establishmentCode !== undefined &&
          item.establishmentDescr !== null &&
          item.establishmentDescr !== undefined
      );
      // Emit event to parent to notify about options availability
      this.$emit("options-loaded", this.options.length > 0);
      if (this.$isset(this.initValue)) {
        this.onChangeField(this.options.find((x) => x.establishmentCode == this.initValue));
      }
    },
    onChangeField(option) {
      this.form[this.name] = option;
      this.$emit(SUC_SELECT_CHANGED_EVENT, this.$deepCopy(this.value));
    },
  },
};
</script>
